import styled, { css, keyframes } from 'styled-components';

const appear = keyframes`
  from { opacity: 0; transform: translateY(8%); }
  to { opacity: 1; transform: translateY(0); }
`;

const fill = keyframes`
  from { transform: scaleX(0.85); }
  to { transform: scaleX(1); }
`;

export const Card = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: ${theme.sz.s12} minmax(0, 1fr) minmax(${theme.sz.s20}, 30%);
    align-items: center;
    gap: ${theme.sz.s4};
    width: 100%;
    padding: ${theme.sz.s4} ${theme.sz.s5};
    border: ${theme.bo.thinWidth} solid ${theme.co.primary80};
    border-radius: ${theme.sz.s5};
    background-color: ${theme.co.neutral99};
    animation: ${appear} 400ms ease-out both;

    @media (max-width: ${theme.sz.md}) {
      grid-template-columns: ${theme.sz.s10} minmax(0, 1fr) minmax(${theme.sz.s16}, 28%);
      gap: ${theme.sz.s3};
      padding: ${theme.sz.s4};
    }

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `,
);

export const Copy = styled.div`
  min-width: 0;
`;

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    margin: 0;
    color: ${theme.co.neutral10};
    overflow-wrap: anywhere;
  `,
);

export const Completed = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    margin: ${theme.sz.s1} 0 0;
    color: ${theme.co.success30};
    font-weight: bold;
  `,
);

export const Progress = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Count = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    align-self: flex-end;
    color: ${theme.co.neutral30};
    font-weight: bold;
    font-variant-numeric: tabular-nums;
  `,
);

export const Track = styled.div(
  ({ theme }) => css`
    height: ${theme.sz.s2};
    margin-top: ${theme.sz.s2};
    overflow: hidden;
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.primary95};
  `,
);

export const Fill = styled.div(
  ({ theme }) => css`
    width: 100%;
    height: 100%;
    border-radius: inherit;
    background-color: ${theme.co.primary20};
    transform-origin: left;
    animation: ${fill} 500ms 100ms ease-out both;

    [dir='rtl'] & {
      transform-origin: right;
    }

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `,
);
